import { Button, Col, message, ModalProps, Radio, Row } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { paymentPackageAssigned } from 'src/api/package_assigned';
import {
  getDetailPackage,
  registerAndCancelPackage,
} from 'src/api/register_and_cancel_and_load_package';
import BoxWithLabel from 'src/components/BoxWithLabel/BoxWithLabel';
import Loading from 'src/components/CLoading';
import ModalConfirm from 'src/components/modals/ModalComfirm';
import { useAppDispatch, useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { resetModalState, setModalState } from 'src/redux/slice/modal.store';
import { TransactionHistoryType } from 'src/shared/enum/localpay';
import { OrderStatusEnum } from 'src/shared/enum/package_assigned';
import { TransactionHistory } from 'src/shared/interface/localpay.interface';
import { OrderRequest } from 'src/shared/interface/package_assigned';
import { formatDateTime, formatMoney } from 'src/utils';
import { usePermission } from 'src/hooks/usePermission';

interface ModalTopUpProps extends ModalProps {
  selectedHistory?: TransactionHistory;
}

function RegisterBillingInfoModal({ selectedHistory }: ModalTopUpProps) {
  const dispatch = useAppDispatch();
  const { order, refresh, balance, openTabs } = useAppSelector((state) => state.global);
  const merchantInfo: string | null = localStorage.getItem('merchantInfo');

  const { hasPermission, PERMISSIONS } = usePermission();

  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [dataDetailLine, setDataDetailLine] = useState<
    {
      mbfCode: string;
      toTalAmount: number;
      countItem: number;
      discountAmount: number;
    }[]
  >([]);
  async function handlePayBill() {
    setIsModalLoading(true);
    setOpenModalConfirm(false);
    if (merchantInfo) {
      const data: OrderRequest = {
        accountNumber: JSON.parse(merchantInfo).payAccountId ?? '',
        orderId: order?.id ? order?.id : '',
        type: 14,
        distibutorId: merchantInfo ? JSON.parse(merchantInfo).merchantId : '',
        description: '',
        updatedBy: merchantInfo ? JSON.parse(merchantInfo).merchantName : '',
      };
      try {
        // thanh toan don hang dang ky goi
        const res = await paymentPackageAssigned(data);
        if (res) {
          const data: OrderRequest = {
            orderId: order?.id ? order?.id : '',
            updatedBy: merchantInfo ? JSON.parse(merchantInfo).merchantName : '',
            // simType: form.getFieldValue('simType'),
          };

          await registerAndCancelPackage('initiate', data);

          dispatch(setGlobalState({ refresh: !refresh }));
          dispatch(setModalState({ open: false }));
          message.success('Thanh toán thành công');
        }
      } catch (error) {
        console.log(error);
        dispatch(setGlobalState({ refresh: !refresh }));
        dispatch(setModalState({ open: false }));
      }
    }
    setIsModalLoading(false);
    dispatch(setGlobalState({ refresh: !refresh }));
  }

  const fetchDetailOrder = async (id: string) => {
    const res = await getDetailPackage('initiate', id);
    if (res) {
      dispatch(setGlobalState({ order: res }));
    }
  };

  const openMenuTab = () => {
    let url = '';
    let label = '';
    if (selectedHistory?.type === TransactionHistoryType.RegisterPackage) {
      url = `order-assigned-package/detail?id=${selectedHistory.paymentId}`;
      label = `Xem chi tiết Gán gói`;
    } else if (selectedHistory?.type === TransactionHistoryType.CancelPackage) {
      url = `register-and-cancel-and-load-package/cancel/detail?id=${selectedHistory.paymentId}`;
      label = `Xem chi tiết Hủy gói`;
    } else if (selectedHistory?.type === TransactionHistoryType.InitiatePackage) {
      url = `register-and-cancel-and-load-package/register/detail?id=${selectedHistory.id}`;
      label = `Xem chi tiết Đăng ký gói`;
    } else if (selectedHistory?.type === TransactionHistoryType.Datacode) {
      url = `register-and-cancel-and-load-package/data-load/detail?id=${
        selectedHistory.paymentId || selectedHistory.id
      }`;
      label = `Xem chi tiết Nạp data`;
    } else {
      url = `changeSim/createChangeSim?id=${selectedHistory?.paymentId}`;
      label = `Xem chi tiết Đổi sim`;
    }
    dispatch(
      setGlobalState({
        activeKeyMenu: `${url}?id=${selectedHistory?.paymentId || selectedHistory?.id}`,
      }),
    );
    dispatch(
      setGlobalState({
        openTabs: [
          ...openTabs,
          {
            label: `${label} ${selectedHistory?.paymentId || selectedHistory?.id}`,
            children: '',
            key: `${url}?id=${selectedHistory?.paymentId || selectedHistory?.id}`,
            closable: true,
          },
        ],
      }),
    );
  };

  useEffect(() => {
    if (selectedHistory && selectedHistory.paymentId) {
      fetchDetailOrder(selectedHistory.paymentId);
    }
  }, [selectedHistory]);

  useEffect(() => {
    if (order) {
      const listDataDetail: {
        mbfCode: string;
        toTalAmount: number;
        countItem: number;
        discountAmount: number;
      }[] = [];
      order?.overFlowOrderDetailResponses?.forEach((item: any) => {
        const findIndexTopup = listDataDetail.findIndex(
          (predicate) => predicate.mbfCode === item?.mbfCode,
        );
        if (findIndexTopup === -1) {
          listDataDetail.push({
            mbfCode: item.mbfCode,
            toTalAmount: item.price,
            countItem: 1,
            discountAmount: item.extraDataObject?.discountAmount,
          });
        } else {
          listDataDetail[findIndexTopup] = {
            ...listDataDetail[findIndexTopup],
            countItem: listDataDetail[findIndexTopup].countItem + 1,
            toTalAmount: listDataDetail[findIndexTopup].toTalAmount + item.price,
            discountAmount:
              listDataDetail[findIndexTopup].discountAmount + item.extraDataObject?.discountAmount,
          };
        }
      });

      setDataDetailLine(listDataDetail);
    }
  }, [order]);

  return (
    <Fragment>
      {isModalLoading && <Loading />}
      <div className='flex justify-end'>
        <button
          onClick={() => dispatch(resetModalState())}
          className=' text-3xl cursor-pointer border-transparent bg-transparent'
        >
          <RxCross2 />
        </button>
      </div>
      <BoxWithLabel title='Thông tin thanh toán' classNames='mb-[1.5rem]'>
        <Row gutter={[12, 12]} className='mb-[1rem]'>
          <Col span={24} md={12}>
            Mã giao dịch: {order?.transactionId}
          </Col>
          <Col span={24} md={12}>
            Người thanh toán: {merchantInfo ? JSON.parse(merchantInfo).merchantName : '-'}
          </Col>
        </Row>
        <Row gutter={[12, 12]} className='mb-[1rem]'>
          <Col span={24} md={12}>
            Đơn hàng tham chiếu:{' '}
            <button
              className={`underline whitespace-nowrap cursor-pointer bg-transparent border-transparent text-blue-400 font-semibold`}
              onClick={(e) => {
                dispatch(resetModalState());
                openMenuTab();
              }}
            >
              {order?.id}
            </button>
          </Col>
          <Col span={24} md={12}>
            Tình trạng: {order?.transactionStatusString}
          </Col>
        </Row>

        <Row gutter={[12, 12]} className='mb-[1rem]'>
          <Col span={24} md={12}>
            Diễn giải: Thanh toán đơn hàng Đăng ký gói
          </Col>
          <Col span={24} md={12}>
            Ngày:{' '}
            {order?.transactionDate && new Date(order.transactionDate).getFullYear() > 1900
              ? formatDateTime(order.transactionDate)
              : formatDateTime(new Date())}
          </Col>
        </Row>
        <p className='font-bold mb-[0.5rem]'>Chi tiết hóa đơn:</p>
        <div className='normal-table max-h-96 overflow-y-auto'>
          <table width='100%' className='normal-table'>
            <thead>
              <tr>
                <th>STT</th>
                <th>Số lượng</th>
                <th>Mã hàng</th>
                <th>Tổng tiền</th>
                <th>Tiền chiết khấu</th>
                <th>Thành tiền</th>
              </tr>
            </thead>
            <tbody>
              {dataDetailLine.map((predicate, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{predicate.countItem ?? 1}</td>
                    <td>{predicate?.mbfCode ? predicate?.mbfCode : ''}</td>
                    <td>
                      {predicate?.toTalAmount ? formatMoney(predicate?.toTalAmount, 'đ') : '-'}
                    </td>
                    <td>
                      {predicate?.discountAmount
                        ? formatMoney(predicate?.discountAmount, 'đ')
                        : '0đ'}
                    </td>
                    <td>
                      {predicate?.toTalAmount
                        ? predicate?.discountAmount
                          ? formatMoney(predicate?.toTalAmount - predicate?.discountAmount, 'đ')
                          : formatMoney(predicate?.toTalAmount, 'đ')
                        : '-'}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td></td>
                <td colSpan={3}>Tổng cộng</td>
                <td>{order?.toTalAmount ? formatMoney(order?.toTalAmount, 'đ') : '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </BoxWithLabel>
      <BoxWithLabel title='Hình thức thanh toán' classNames='mb-[1.5rem]'>
        <Radio checked className='mb-[0.5rem]'>
          Localpay
        </Radio>
        <Row gutter={[12, 8]}>
          <Col span={24} md={8}>
            LocalPay ID: {merchantInfo ? JSON.parse(merchantInfo).payAccountId : '-'}
          </Col>
          <Col
            span={24}
            md={
              order?.statusString === OrderStatusEnum.PAYMENT_FAIL ||
              order?.statusString === OrderStatusEnum.New
                ? 8
                : 12
            }
          >
            Tên chủ tài khoản: {merchantInfo ? JSON.parse(merchantInfo).merchantName : '-'}
          </Col>
          {(order?.statusString === OrderStatusEnum.PAYMENT_FAIL ||
            order?.statusString === OrderStatusEnum.New) && (
            <>
              <Col span={24} md={8}>
                Số dư: {balance ? formatMoney(balance, 'đ') : '-'}
              </Col>
            </>
          )}
        </Row>
      </BoxWithLabel>
      {!(
        order?.transactionStatusString === OrderStatusEnum.PAYMENT_FAIL ||
        order?.statusString === OrderStatusEnum.New
      ) && (
        <Row className='my-4 border px-4 py-2' gutter={[12, 12]}>
          <Col span={24} md={12}>
            Người tạo: {order?.createdBy}
          </Col>
          <Col span={24} md={12}>
            Ngày tạo: {order?.createdAt ? formatDateTime(order.createdAt) : '-'}
          </Col>
        </Row>
      )}
      {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.REGISTER_PAYMENT) &&
        (order?.statusString === OrderStatusEnum.PAYMENT_FAIL ||
          order?.statusString === OrderStatusEnum.New) && (
          <div className='row-button justify-end'>
            <Button
              onClick={() => setOpenModalConfirm(true)}
              disabled={
                order?.statusString !== OrderStatusEnum.PAYMENT_FAIL &&
                order?.statusString !== OrderStatusEnum.New
              }
            >
              Thanh toán
            </Button>
          </div>
        )}
      <ModalConfirm
        open={openModalConfirm}
        content={
          <div className='pb-0 p-8'>
            <div className='font-black text-3xl mb-4'>Xác nhận thanh toán?</div>
            <p>
              Bạn có chắc chắn muốn thanh toán{' '}
              {order?.toTalAmount ? formatMoney(order?.toTalAmount, 'đ') : '-'} cho đơn hàng này?
            </p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button onClick={handlePayBill} className='h-full w-full' disabled={isModalLoading}>
                XÁC NHẬN
              </Button>
              <Button
                className='h-full w-full'
                onClick={() => {
                  setOpenModalConfirm(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
    </Fragment>
  );
}

export default RegisterBillingInfoModal;
